(function () {
  'use strict';

  const SELECTORS = '.slider--desktop, .slider--tablet-up, .slider--everywhere';
  const DRAG_THRESHOLD = 5;

  function attach(el) {
    if (el.dataset.dragAttached) return;
    el.dataset.dragAttached = '1';

    let startX = 0;
    let scrollLeft = 0;
    let isDown = false;
    let hasDragged = false;

    function onMouseDown(e) {
      if (e.button !== 0) return;
      isDown = true;
      hasDragged = false;
      startX = e.pageX - el.offsetLeft;
      scrollLeft = el.scrollLeft;
      el.classList.add('is-dragging');
    }

    function onMouseUp() {
      isDown = false;
      el.classList.remove('is-dragging');
    }

    function onMouseLeave() {
      isDown = false;
      el.classList.remove('is-dragging');
    }

    function onMouseMove(e) {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - el.offsetLeft;
      const walk = x - startX;
      if (Math.abs(walk) > DRAG_THRESHOLD) hasDragged = true;
      el.scrollLeft = scrollLeft - walk;
    }

    // Capture phase: swallow any click that followed a real drag
    function onClickCapture(e) {
      if (hasDragged) {
        e.preventDefault();
        e.stopPropagation();
        hasDragged = false;
      }
    }

    el.addEventListener('mousedown', onMouseDown);
    el.addEventListener('mouseup', onMouseUp);
    el.addEventListener('mouseleave', onMouseLeave);
    el.addEventListener('mousemove', onMouseMove);
    el.addEventListener('click', onClickCapture, true);
  }

  function attachAll() {
    document.querySelectorAll(SELECTORS).forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachAll);
  } else {
    attachAll();
  }

  // Theme editor section reloads
  document.addEventListener('shopify:section:load', attachAll);

  // AJAX-loaded content (product recommendations, cart upsells, etc.)
  const observer = new MutationObserver(attachAll);
  observer.observe(document.body, { childList: true, subtree: true });
})();
